var render, staticRenderFns
import script from "./yp-doc.vue?vue&type=script&lang=js"
export * from "./yp-doc.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./yp-doc.vue?vue&type=style&index=0&id=adcca01e&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "14eefaf7"
  
)

export default component.exports